import { render, staticRenderFns } from "./uploadProof.vue?vue&type=template&id=653f2665&scoped=true"
import script from "./uploadProof.vue?vue&type=script&lang=js"
export * from "./uploadProof.vue?vue&type=script&lang=js"
import style0 from "./uploadProof.vue?vue&type=style&index=0&id=653f2665&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653f2665",
  null
  
)

export default component.exports